import React from "react";

import { useTranslation } from "react-i18next";

import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";
import { BetStatusAbrv } from "@data-types/bet-slip/BetStatus";
import { getDisplayedAmount } from "@utils";
import { isNullOrWhitespace } from "@utils/utility";

export function AdditionalGain(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	const t = useTranslation().t;

	if (props.slipDetails.betStatus.abrv != BetStatusAbrv.WON) {
		return null;
	}

	if (
		!props.slipDetails.gain ||
		isNullOrWhitespace(props.slipDetails.gain.toString())
	) {
		return null;
	}

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd u-color--sent--success">
				{t<string>("ACC_STATEMENT.BET_DETAILS.ADDITIONAL_GAIN")}
			</td>
			<td className="table--bets__dd u-color--sent--success">
				{getDisplayedAmount(props.slipDetails.gain)}
			</td>
		</tr>
	);
}
